import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 570px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
